// Lets non-React code (axios response interceptors, the fetch-based 401
// handler in actions/helper.js) trigger a logout without importing the
// Redux store singleton. Mirrors the setBrowserHarnessFactory pattern in
// src/api/harness/browserHarnessFlag.ts, which solves the same
// "expose a Context/factory value to code outside the React tree" problem
// for the Split.io factory. AuthProvider registers its dispatch here on
// mount (see AuthProvider.tsx).
let logout: (() => void) | null = null;

export const setAuthLogoutTrigger = (nextLogout: (() => void) | null) => {
  logout = nextLogout;
};

// Unregisters `nextLogout` only if it is still the registered trigger, so an
// unmounting provider can't clobber one that registered after it.
export const clearAuthLogoutTrigger = (nextLogout: () => void) => {
  if (logout === nextLogout) logout = null;
};

// ECDEX-3441 (MR E): logs out Redux and the AuthProvider Context together (see
// the registration in AuthProvider.tsx). A no-op until a provider has mounted.
export const triggerAuthLogout = (): void => {
  logout?.();
};
